import Icon from '../../components/Icon.vue'

Icon.register({"regular/compass":{"width":512,"height":512,"paths":[{"d":"M256 8C119 8 8 119 8 256S119 504 256 504 504 393 504 256 393 8 256 8zM256 456C145.5 456 56 366.5 56 256 56 145.5 145.5 56 256 56 366.5 56 456 145.5 456 256 456 366.5 366.5 456 256 456zM347.3 143.9L314 281.6A24-24 0 0 0 307.2 293.4L204.6 391.2C187.5 407.4 159 391.6 164.7 368.1L198 230.4A24-24 0 0 0 204.8 218.6L307.4 120.8C324.7 104.4 352.9 120.7 347.3 143.9zM256 224C238.3 224 224 238.3 224 256S238.3 288 256 288 288 273.7 288 256 273.7 224 256 224z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/compass.js
// module id = null
// module chunks = 